// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-inspector-sources__title {
  font-size: var(--g-text-body-3-font-size);
  line-height: var(--g-text-body-3-line-height);
  font-weight: 500;
}
.chartkit-inspector-sources__body_centered {
  display: flex;
  justify-content: center;
}
.chartkit-inspector-sources__source {
  display: grid;
  grid-template-columns: auto 70px 70px;
  padding: 10px 0;
  align-items: center;
  min-height: 42px;
}
.chartkit-inspector-sources__source_collapsible {
  grid-template-columns: auto 70px 70px 15px;
  cursor: pointer;
}
.chartkit-inspector-sources__source_collapsible .chartkit-inspector-sources__metric {
  text-align: left;
}
.chartkit-inspector-sources__source_error {
  grid-template-columns: auto 70px 15px;
}
.chartkit-inspector-sources__source_collapsed:not(:last-child) {
  border-bottom: 1px solid var(--g-color-line-generic);
}
.chartkit-inspector-sources__metric {
  color: var(--g-color-text-secondary);
  text-align: right;
}
.chartkit-inspector-sources__metric_warning {
  color: var(--g-color-text-warning);
}
.chartkit-inspector-sources__metric.chartkit-inspector-sources__metric_danger {
  color: var(--g-color-text-danger);
}
.chartkit-inspector-sources__source-expanded {
  border-bottom: 1px solid var(--g-color-line-generic);
}
.chartkit-inspector-sources__source-meta_centered {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/Menu/Items/Inspector/Sources/Sources.scss"],"names":[],"mappings":"AAGI;EACI,yCAAA;EACA,6CAAA;EACA,gBAAA;AAFR;AAMQ;EACI,aAAA;EACA,uBAAA;AAJZ;AAQI;EACI,aAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AANR;AAQQ;EACI,0CAAA;EACA,eAAA;AANZ;AAQY;EACI,gBAAA;AANhB;AAUQ;EACI,qCAAA;AARZ;AAWQ;EACI,oDAAA;AATZ;AAaI;EACI,oCAAA;EACA,iBAAA;AAXR;AAaQ;EACI,kCAAA;AAXZ;AAcQ;EACI,iCAAA;AAZZ;AAgBI;EACI,oDAAA;AAdR;AAkBQ;EACI,aAAA;EACA,uBAAA;AAhBZ","sourcesContent":[".chartkit-inspector-sources__title {\n  font-size: var(--g-text-body-3-font-size);\n  line-height: var(--g-text-body-3-line-height);\n  font-weight: 500;\n}\n.chartkit-inspector-sources__body_centered {\n  display: flex;\n  justify-content: center;\n}\n.chartkit-inspector-sources__source {\n  display: grid;\n  grid-template-columns: auto 70px 70px;\n  padding: 10px 0;\n  align-items: center;\n  min-height: 42px;\n}\n.chartkit-inspector-sources__source_collapsible {\n  grid-template-columns: auto 70px 70px 15px;\n  cursor: pointer;\n}\n.chartkit-inspector-sources__source_collapsible .chartkit-inspector-sources__metric {\n  text-align: left;\n}\n.chartkit-inspector-sources__source_error {\n  grid-template-columns: auto 70px 15px;\n}\n.chartkit-inspector-sources__source_collapsed:not(:last-child) {\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.chartkit-inspector-sources__metric {\n  color: var(--g-color-text-secondary);\n  text-align: right;\n}\n.chartkit-inspector-sources__metric_warning {\n  color: var(--g-color-text-warning);\n}\n.chartkit-inspector-sources__metric.chartkit-inspector-sources__metric_danger {\n  color: var(--g-color-text-danger);\n}\n.chartkit-inspector-sources__source-expanded {\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.chartkit-inspector-sources__source-meta_centered {\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
